<script>
  export let rows = 5;
  export let height = 80;

  // map a value between range of 0.4 and 1
  function map(value, in_min, in_max, out_min, out_max) {
    return ((value - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min;
  }
</script>

{#each Array(rows).fill(0) as _, i}
  <div
    class="mt-1 w-full bg-color-slate-base animate-pulse rounded-10"
    style="opacity: {map(i, 0, rows, 0, 1)}; height: {height}px"
  />
{/each}
